import { LazyLoader, Modal } from '@bp/ui-components';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CurriculumForm } from '../Forms/CurriculumForm';

type CurriculumModalProps = {
  versionUuid: string | null;
  curriculumUuid: string | null;
  isOpen: boolean;
  onClose: () => void;
};

export const CurriculumModal = ({ versionUuid, curriculumUuid, isOpen, onClose }: CurriculumModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      title={curriculumUuid ? t('curriculum.edit') : t('curriculum.add')}
      loading={loading}
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <Suspense fallback={<LazyLoader embedded forceHeight='40vh' />}>
        <CurriculumForm
          versionUuid={versionUuid}
          curriculumUuid={curriculumUuid}
          defaultInitialValues={{
            curriculumVersionUuid: versionUuid ?? '',
            subject: undefined,
            timetableEnabled: true,
            teachingLoadEnabled: true,
          }}
          onLoad={setLoading}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
